var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V24.3941H0V-0.00585938ZM0 48.8941H513V73.2941H0V48.8941ZM0 97.6941H513V122.094H0V97.6941ZM0 146.594H513V170.994H0V146.594ZM0 195.394H513V219.794H0V195.394ZM0 244.294H513V268.694H0V244.294ZM0 293.094H513V317.494H0V293.094Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H256.5V195.394H0V-0.00585938Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3 42.0942C122.6 30.6942 88.4999 46.2942 77.0999 76.9942C65.6999 107.694 81.2999 141.794 112 153.194C125.3 158.194 140 158.194 153.4 153.194C122.7 177.694 77.9999 172.794 53.3999 142.094C28.7999 111.394 33.7999 66.6942 64.4999 42.0942C90.4999 21.3942 127.4 21.3942 153.3 42.0942ZM180 117.094L159.4 140.394L164.8 109.794L133.8 108.194L161.1 93.2942L143 67.9942L171.6 79.9942L180 50.0942L188.4 79.9942L217 67.9942L199 93.3942L226.3 108.294L195.3 109.894L200.7 140.494L180 117.094Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.a7b334e5f3d99eefcf342496f0abfdea.svg";
export { ForwardRef as ReactComponent };